import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import "./completedOrders.scss";
import * as service from "./completedOrdersServices";
import DatePicker from "react-datepicker";
import Moment from "moment";

import {
  timestampToDateYearAndTime,
  log,
  getMapIdBasedonEnvironment,
} from "../../helper/helper";
import ridingImage from "../../assets/riding.png";
import walkingImage from "../../assets/walking.png";
import cyclingImage from "../../assets/cycling.png";
import drivingImage from "../../assets/driving.png";
import { Col, Divider, Row } from "antd";
import decodePolyline from "decode-google-map-polyline";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";

function CompletedOrders(props) {
  const [transports, setTransports] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [cursorTransportId, setCursorTransportId] = useState("");
  const [isHidden, setBtnHidden] = useState(false);
  const [startData, setStartDate] = useState("");
  const [endData, setEndDate] = useState("");
  const [totalPaidBearers, setTotalPaidBearers] = useState(0);
  const [totalPaidCustomers, setTotalPaidCustomers] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);

  const [totalFinalPaidRider, setTotalFinalPaidRider] = useState();
  const [totalOriginalPayableRider, setTotalOriginalPayableRider] = useState();
  const [totalTransportOriginalPrice, setTotalTransportOriginalPrice] =
    useState();
  const [totalTransportReceivablePrice, setTotalTransportReceivablePrice] =
    useState();

  const maxdate = new Date();

  const [positions, setPositions] = useState([]);
  const [map, setMap] = React.useState(null);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
    });
    let bearersTotal = 0;
    let customersTotal = 0;

    const filtered =
      selectedIds.length > 0
        ? transports.filter((t) => selectedIds.includes(t.transport_id))
        : transports;

    bearersTotal = filtered.reduce(
      (sum, t) => sum + (t.final_paid_to_rider || 0),
      0
    );

    customersTotal = filtered.reduce(
      (sum, t) => sum + (t.transport_receivable_price || 0),
      0
    );

    setTotalPaidBearers(bearersTotal);
    setTotalPaidCustomers(customersTotal);
  }, [selectedIds, transports]);

  const handleTransportDate = (time) => {
    return timestampToDateYearAndTime(time._seconds, time._nanoseconds);
  };

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const onLoadBounds = (map) => {
    if (!map) {
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    map.fitBounds(bounds);
    setMap(map);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const options = {
    fillColor: "lightblue",
    fillOpacity: 1,
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };

  const loadGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={onLoadBounds}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {positions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}
        {transports.map((trip, idx) => (
          <Polyline
            key={`polyline-${idx}`}
            path={decodePolyline(trip.overview_polyline)}
            options={options}
          />
        ))}
        <></>
      </GoogleMap>
    );
  };

  const handleSelectedRow = (transport) => {
    setSelectedIds((prev) =>
      prev.includes(transport.transport_id)
        ? prev.filter((id) => id !== transport.transport_id)
        : [...prev, transport.transport_id]
    );
  };

  const adminGetReportForCompleteTransport = async (newCall) => {
    if (startData === "") {
      return toast.error("Start date couldn't be empty");
    }
    if (endData === "") {
      return toast.error("End date couldn't be empty");
    }

    const paging = newCall ? "" : cursorTransportId;
    setLoading(true);
    try {
      const result = await service.adminGetReportForCompleteTransport(
        Moment(startData).format("YYYY-MM-DD"),
        Moment(endData).format("YYYY-MM-DD"),
        paging
      );
      setLoading(false);
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            if (newCall) {
              adminGetFinancialReportForTransports();
              setTransports(result.data.transportList);
            } else {
              const list = [...transports, ...result.data.transportList];
              setTransports(list);
            }
            if (result.data.cursor_transport_id) {
              setCursorTransportId(result.data.cursor_transport_id);
              setBtnHidden(false);
            } else {
              setCursorTransportId("");
              setBtnHidden(true);
            }

            let positionsData = [];
            for (const trip of result.data.transportList) {
              positionsData.push(
                {
                  lat: trip.origin_geopoint._latitude,
                  lng: trip.origin_geopoint._longitude,
                  icon: origin,
                  zIndex: 9,
                },
                {
                  lat: trip.destination_geopoint._latitude,
                  lng: trip.destination_geopoint._longitude,
                  icon: destination,
                  zIndex: 9,
                }
              );
            }
            if (newCall) {
              setPositions(positionsData);
            } else {
              setPositions([...positions, ...positionsData]);
            }

            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const adminGetFinancialReportForTransports = async () => {
    if (startData === "") {
      return toast.error("Start date couldn't be empty");
    }
    if (endData === "") {
      return toast.error("End date couldn't be empty");
    }
    setLoading(true);
    try {
      const result = await service.adminGetFinancialReportForTransports(
        Moment(startData).format("YYYY-MM-DD"),
        Moment(endData).format("YYYY-MM-DD")
      );
      setLoading(false);
      log(result);
      if (result) {
        setLoading(false);
        switch (result.data.code) {
          case 200:
            setTotalFinalPaidRider(result.data.total_final_paid_to_rider);
            setTotalOriginalPayableRider(
              result.data.total_original_payable_to_rider
            );
            setTotalTransportOriginalPrice(
              result.data.total_transport_original_price
            );
            setTotalTransportReceivablePrice(
              result.data.total_transport_receivable_price
            );
            return;
          case 401:
            toast.error(result.data.message);
            return props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const handleBearerType = (bearer) => {
    switch (bearer) {
      case "driving":
        return (
          <div className="bearer">
            <img src={drivingImage} alt="rider" />
          </div>
        );
      case "riding":
        return (
          <div className="bearer">
            <img src={ridingImage} alt="rider" />
          </div>
        );
      case "cycling":
        return (
          <div className="bearer">
            <img src={cyclingImage} alt="cycle" />
          </div>
        );
      case "walking":
        return (
          <div className="bearer">
            <img src={walkingImage} alt="walk" />
          </div>
        );

      default:
        break;
    }
  };

  return (
    <div className="show-all-list data-server-list completed-orders">
      <ToastContainer />
      {renderSpinner()}
      <div className="filter-section">
        <Row gutter={16}>
          <Col span="10">
            <div
              className="form-group"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label
                htmlFor="dateTime"
                style={{ marginBottom: 20, marginRight: 5 }}
              >
                Start:
              </label>
              <DatePicker
                selected={startData}
                onChange={(date) => {
                  setCursorTransportId("");
                  setStartDate(date);
                }}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                maxDate={maxdate}
              />
            </div>
          </Col>
          <Col span="10">
            <div
              className="form-group"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label
                htmlFor="dateTime"
                style={{ marginBottom: 20, marginRight: 5 }}
              >
                End:
              </label>
              <DatePicker
                selected={endData}
                onChange={(date) => {
                  setCursorTransportId("");
                  setEndDate(date);
                }}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                maxDate={maxdate}
              />
            </div>
          </Col>
          <Col span="2" style={{ textAlign: "right" }}>
            <button
              className="search-view"
              onClick={() => {
                setPositions([]);
                adminGetReportForCompleteTransport(true);
              }}
              style={{ margin: "10px 0 20px" }}
            >
              Search
            </button>
          </Col>
        </Row>
      </div>
      {transports.length > 0 && (
        <>
          <div style={{ padding: "20px 0" }}>
            <Row gutter={16}>
              <Col span="12">
                <div className="reports-number blue">
                  <span>Original Price</span>
                  <span style={{ fontWeight: "bold", fontSize: 18 }}>
                    {totalTransportOriginalPrice &&
                      totalTransportOriginalPrice.toFixed(2)}
                  </span>
                </div>
              </Col>
              <Col span="12">
                <div className="reports-number green">
                  <span>Total Paid to Customers</span>
                  <span style={{ fontWeight: "bold", fontSize: 18 }}>
                    {totalTransportReceivablePrice &&
                      totalTransportReceivablePrice.toFixed(2)}
                  </span>
                </div>
              </Col>
              <Col span="12">
                <div className="reports-number orange">
                  <span>Original Payable to Bearers</span>
                  <span style={{ fontWeight: "bold", fontSize: 18 }}>
                    {totalFinalPaidRider && totalFinalPaidRider.toFixed(2)}
                  </span>
                </div>
              </Col>
              <Col span="12">
                <div className="reports-number pink">
                  <span>Final Paid to Bearers</span>
                  <span style={{ fontWeight: "bold", fontSize: 18 }}>
                    {totalOriginalPayableRider &&
                      totalOriginalPayableRider.toFixed(2)}
                  </span>
                </div>
              </Col>
            </Row>
            <Divider />
            <Row gutter={16}>
              <Col span="12">
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#f00",
                  }}
                >
                  Total Paid to Bearers: {totalPaidBearers.toFixed(2)}
                </div>
              </Col>
              <Col span="12">
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#71cf9a",
                  }}
                >
                  Total Paid to Customers: {totalPaidCustomers.toFixed(2)}
                </div>
              </Col>
            </Row>
          </div>
          <h6 style={{ margin: "20 0" }}>
            Found {transports.length}{" "}
            {transports.length > 1 ? "results" : "result"}
          </h6>
          {positions.length > 0 && (
            <div className="map"> {loadGoogleMap()}</div>
          )}
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Origin Address</th>
                <th>Customer Name</th>
                <th>Destination Address</th>
                <th>Bearer Name</th>
                <th>Assigned MoT</th>
                <th>Final Paid by Customer</th>
                <th>Final Paid to Rider</th>
                <th>(More Details)</th>
              </tr>
            </thead>
            <tbody>
              {transports.map((transport) => (
                <tr
                  key={transport.transport_id}
                  onClick={() => handleSelectedRow(transport)}
                  style={{
                    backgroundColor: selectedIds.includes(
                      transport.transport_id
                    )
                      ? "#dee2e6"
                      : "transparent",
                    cursor: "pointer",
                  }}
                >
                  <td>{handleTransportDate(transport.time)}</td>
                  <td>{transport.origin_address}</td>
                  <td>
                    {transport.customer_given_name
                      ? transport.customer_given_name
                      : "" + " " + transport.customer_last_name
                      ? transport.customer_last_name
                      : ""}
                  </td>
                  <td>{transport.destination_address}</td>
                  {/* <td>{transport.latest_status}</td> */}
                  <td>
                    {transport.rider_given_name +
                      " " +
                      transport.rider_last_name}
                  </td>
                  <td>{handleBearerType(transport.bearer_type)}</td>
                  <td>{"A$ " + transport.transport_receivable_price}</td>
                  <td>{"A$ " + transport.final_paid_to_rider}</td>
                  <td>
                    <button
                      onClick={() =>
                        props.history.push("/home/transportSingle", {
                          transportId: transport.transport_id,
                        })
                      }
                      className="single-view"
                    >
                      view
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="load-more">
            <button
              hidden={isHidden}
              onClick={() => adminGetReportForCompleteTransport(false)}
            >
              Load More
            </button>
          </div>
        </>
      )}
    </div>
  );
}
export default CompletedOrders;
